
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class SubjectsGrid extends Serenity.EntityGrid<SubjectsRow, any> {
        protected getColumnsKey() { return SubjectsColumns.columnsKey; }
        protected getDialogType() { return SubjectsDialog; }
        protected getIdProperty() { return SubjectsRow.idProperty; }
        protected getInsertPermission() { return SubjectsRow.insertPermission; }
        protected getLocalTextPrefix() { return SubjectsRow.localTextPrefix; }
        protected getService() { return SubjectsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}